import { ClipboardList, Gauge } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const auditsNav: NavEntry[] = [
  { label: 'Audits', icon: ClipboardList, path: '/audits', permission: 'audits:read', order: 16 },
  { label: 'Inspections', icon: Gauge, path: '/inspections', permission: 'audits:read', order: 17 },
]
